export enum EStatusNotaFiscal {
    Pendente = 1,
    Autorizada = 2,
    Cancelada = 3,
    EmitidaEmContigencia = 4
}
